module.exports = __webpack_public_path__ + "img/ssml.c1f222ef.png";